import { render, staticRenderFns } from "./stockproductpurchasev2.vue?vue&type=template&id=31a15776&scoped=true&"
import script from "./stockproductpurchasev2.vue?vue&type=script&lang=js&"
export * from "./stockproductpurchasev2.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./stockproductpurchasev2.vue?vue&type=style&index=1&id=31a15776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a15776",
  null
  
)

export default component.exports